import { locales } from '@americanexpress/conditional-features';
import { devFlagByConfigs, devFlagStopAt } from './devFlagUtils';
import {
  CONSUMER_TRAVEL,
  e1,
  e2,
  e3,
  STAGING,
  TRAVEL_ISEATZ,
  PREBOOKING,
} from './devFlagConstants';

const {
  EN_US,
} = locales;

/**
 * Declares if the feature should be on or off with some helper functions exist,
 * state will be passed in as param
 * E.G.:
 *
 *  devFlagByConfigs(
 *    [{ envToStopAt: 'E2', tenancies: ['STAGING', 'CONSUMER-TRAVEL'] },
 *    { envToStopAt: 'E2', tenancies: ['PREBOOKING'] }]
 *    state
 *  ):
 *    A feature is available in E1, E2 for tenancies: Staging, Consumer-Travel
 *              is also available in E1, E2 for tenancies: PREBOOKING
 *  devFlagStopAt(
 *    [{ envToStopAt: 'E2'}],
 *    state
 *  ):
 *    A feature is available in E1, E2 for all tenancies.
 */
const generateDevFlagConfig = (state) => {
  global.consumerTravelDevFlags = {
    explorationContainer: devFlagStopAt(state, { envToStopAt: e2, tenancies: [STAGING] }),
    homepageFHM: false,
    intlHomepageCenturionRollout: devFlagStopAt(state, { envToStopAt: e2, tenancies: [STAGING] }),
    intlTravelCreditTab: devFlagStopAt(state, {
      envToStopAt: e3,
      tenancies: [STAGING],
    }),
    linkWall: true,
    mobileShowMoreDatepicker: devFlagStopAt(state, {
      envToStopAt: e2, tenancies: [STAGING],
    }),
    popularDestinationsLocations: devFlagStopAt(state, { envToStopAt: e2, tenancies: [STAGING] }),
    strategicInitiative: devFlagStopAt(state, {
      envToStopAt: e2,
      tenancies: [TRAVEL_ISEATZ],
    }),
    tealeafIntl: true,
    travelBenefitsAPI: devFlagByConfigs(state, [
      { envToStopAt: e3, tenancies: [STAGING], locales: [EN_US] },
      { envToStopAt: e3, tenancies: [CONSUMER_TRAVEL, PREBOOKING], locales: [EN_US] },
    ]),
    travelerApiV2: true,
    usTravelApiV2: devFlagStopAt(state,
      {
        envToStopAt: e1, tenancies: [STAGING],
      }),
    abandonHotel: devFlagStopAt(state, { envToStopAt: e2, tenancies: [STAGING] }),
    profileMarketingTile: devFlagStopAt(state, { envToStopAt: e2, tenancies: [STAGING] }),
    earlyTenureMarketingTile: devFlagStopAt(state, {
      envToStopAt: e2, tenancies: [STAGING],
    }),
    recentSearchHotel: devFlagByConfigs(state, [
      { envToStopAt: e3, tenancies: [STAGING] },
      { envToStopAt: e2, tenancies: [CONSUMER_TRAVEL, PREBOOKING] },
    ]),
    projectAds: devFlagByConfigs(state, [
      { envToStopAt: e3, tenancies: [STAGING] },
      { envToStopAt: e3, tenancies: [CONSUMER_TRAVEL, PREBOOKING] },
    ]),
    marketingPage: devFlagByConfigs(state, [
      { envToStopAt: e3, tenancies: [STAGING] },
      { envToStopAt: e3, tenancies: [CONSUMER_TRAVEL, PREBOOKING] },
    ]),
    lxpSearch: devFlagByConfigs(state, [
      {
        envToStopAt: e2,
        tenancies: [TRAVEL_ISEATZ],
      },
    ]),
    luxuryHotelsDedicated: devFlagByConfigs(state, [
      { envToStopAt: e3, tenancies: [STAGING] },
      { envToStopAt: e2, tenancies: [CONSUMER_TRAVEL, PREBOOKING, TRAVEL_ISEATZ] },
    ]),
  };
  return global.consumerTravelDevFlags;
};

export default generateDevFlagConfig;
